"use strict";
/**
 * Frontend TypeScript interfaces for async job status operations
 * These mirror the backend DTOs but adapted for frontend usage
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobStatusEnum = void 0;
var JobStatusEnum;
(function (JobStatusEnum) {
    JobStatusEnum["WAITING"] = "waiting";
    JobStatusEnum["ACTIVE"] = "active";
    JobStatusEnum["COMPLETED"] = "completed";
    JobStatusEnum["FAILED"] = "failed";
    JobStatusEnum["NOT_FOUND"] = "not-found";
})(JobStatusEnum || (exports.JobStatusEnum = JobStatusEnum = {}));
